import { memo, FC, Fragment } from 'react'

import { MathVaultLink } from '~/types/math-vault'

import { applyClassNames } from '~/utils'

import MenuItem from './components/MenuItem'

interface HorizontalMenuProps {
  links: MathVaultLink[]
  title: string
}

const HorizontalMenu: FC<HorizontalMenuProps> = ({ links, title }) => {
  const containerClassNames = {
    size: 'xl:max-w-max',
  }

  const horizontalNavClassNames = {
    box: {
      model: 'flex items-center justify-evenly',
      style: 'rounded shadlow-large bg-white',
    },
    position: 'relative self-start',
    size: 'max-w-max',
    spacing: 'px-3 space-x-1 ',
  }

  return (
    <div className={applyClassNames(containerClassNames)}>
      <h1 className="h-auto my-0 text-h3 my-8 text-gray-dashboard-header ">{title}</h1>
      <div className={applyClassNames(horizontalNavClassNames)}>
        {links?.map((link, index) => {
          if (index !== links.length - 1) {
            return (
              <Fragment key={link.key}>
                <MenuItem link={link} />
                <div className="shrink-0 w-px h-4 bg-gray-light-fade" />
              </Fragment>
            )
          }
          return <MenuItem key={link.key} link={link} />
        })}
      </div>
    </div>
  )
}

export default memo(HorizontalMenu)
